import React from 'react';

import Config from '../../config.json';

import '../CardSectionStyles.css';

function Razorpay({ paymentOrder }) {
  function loadScript(src) {
    return new Promise((resolve) => {
      const script = document.createElement('script');
      script.src = src;
      script.onload = () => {
        resolve(true);
      };
      script.onerror = () => {
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  async function displayRazorpay() {
    const res = await loadScript('https://checkout.razorpay.com/v1/checkout.js');

    if (!res) {
      // alert('Razorpay SDK failed to load. Are you online?');
      return;
    }

    const { amount, orderId, currency } = paymentOrder;

    const options = {
      key: Config.razorpayKey,
      amount: (amount * 100).toString(),
      currency,
      order_id: orderId,
      async handler(response) {
        const paymentId = response.razorpay_payment_id;
        const razorpayOrderId = response.razorpay_order_id;
        if (paymentId && razorpayOrderId) {
          window.location.href = `/payment/order?order_id=${razorpayOrderId}&success=true`;
        } else {
          window.location.href = `/payment/order?order_id=${razorpayOrderId}`;
        }
      },
      notes: {
        address: 'Stamurai',
      },
    };

    const paymentObject = new window.Razorpay(options);
    paymentObject.open();
  }

  return (
    <div>
      <button type="submit" onClick={displayRazorpay}>
        Pay Now
      </button>
    </div>
  );
}

export default Razorpay;
